import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Role } from '../../modules/roles/role.interface';
import { RoleService } from './role.service';

const service = new RoleService();

export interface RoleState {}

const RoleStore: Module<RoleState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getRoles(context, userId: number) {
         return await service.getRoles(userId);
      },
      async addRoles(context, payload: { userId: number; roles: Array<Role> }) {
         return await service.postRolesBatch(payload.userId, payload.roles);
      },
      async deleteRoles(context, payload: { userId: number; roles: Array<Role> }) {
         return await service.deleteRolesBatch(payload.userId, payload.roles);
      },
   },
};

export default RoleStore;
